import * as React from "react";
// import { Spinner } from "./Icons/Icons";

type Props = {};

export const Loading: React.FunctionComponent<Props> = () => {
  return (
    <div className="new-grid product-grid collection-grid">
      <div className=" justify-center ">
        <div id="loading">
          <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48">
            <path d="M26.35 44v-3q1.75-.3 3.45-.975 1.7-.675 3.3-1.875l2.15 2.2q-2 1.5-4.25 2.4-2.25.9-4.65 1.25Zm-4.5 0q-6.85-1.05-11.3-6.1Q6.1 32.85 6.1 25.85q0-3.75 1.4-7.025 1.4-3.275 3.85-5.725 2.45-2.45 5.725-3.85 3.275-1.4 7.025-1.4h1L21.15 3.9l2.2-2.2L31 9.35 23.35 17l-2.2-2.2 3.95-3.95h-1q-6.35 0-10.675 4.325Q9.1 19.5 9.1 25.85q0 5.85 3.625 9.975T21.85 41Zm16.55-6.8L36.2 35q1.15-1.5 1.825-3.25t.925-3.65H42q-.35 2.55-1.275 4.875Q39.8 35.3 38.4 37.2ZM42 23.6h-3.05q-.25-1.75-.925-3.5T36.2 16.7l2.2-2.15q1.45 2 2.35 4.275.9 2.275 1.25 4.775Z" />
          </svg>
        </div>
        <h2 className="h6">Loading</h2>
      </div>
    </div>
  );
};
